import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { AUTH_TOKEN_KEY } from "@/lib/admin";
import ErrorBoundary from "@/components/ErrorBoundary";

/** Android WebView injects token into sessionStorage; sync to localStorage so AuthContext sees it. */
function syncScjaTokenFromSession(): void {
  if (typeof window === "undefined") return;
  const token = sessionStorage.getItem("scja_access_token");
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    sessionStorage.removeItem("scja_access_token");
    sessionStorage.removeItem("scja_redirect");
  }
}

/** Android app can post updated tokens via postMessage without reloading the WebView. */
function listenForTokenMessages(): void {
  if (typeof window === "undefined") return;
  window.addEventListener("message", (event) => {
    if (!event.data || typeof event.data !== "object") return;
    const { type, token } = event.data as { type?: string; token?: string };
    if (type === "scja_token_update" && typeof token === "string" && token.trim()) {
      localStorage.setItem(AUTH_TOKEN_KEY, token.trim());
      window.dispatchEvent(new CustomEvent("auth:token-updated"));
    }
  });
}

syncScjaTokenFromSession();
listenForTokenMessages();
createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
